const checkSpanishLanguage = (options) => {
    if (!options || !options.model) {
        // check options is not exists return false;
        return false;
    }
    const lang = options.language || options.model.language;
    return lang === 'sps' || lang === 'spa';
};
export default checkSpanishLanguage;
